"use strict";
exports.__esModule = true;
exports.buttonColors = exports.elementColors = exports.selectionElementColors = exports.alertColors = exports.profileColors = exports.borderColors = exports.gradientsColors = exports.fontColors = exports.statusColors = exports.logoColors = exports.credentialCardColors = exports.backgroundColors = void 0;
exports.backgroundColors = {
    primaryDark: '#202537',
    secondaryDark: '#2C334B',
    primaryLight: '#FBFBFB',
    secondaryLight: '#E3E3FF',
    lightGrey: '#E3E3E3',
    orange: '#D74500'
};
exports.credentialCardColors = {
    "default": '#5BDED2'
};
exports.logoColors = {
    "default": '#FBFBFB'
};
exports.statusColors = {
    valid: '#00C249',
    expired: '#FF9900',
    revoked: '#EE5309',
    verified: '#00C249',
    unverified: '#FF9900',
    error: '#D74500',
    "new": '#7276F7',
    approved: '#00C249',
    pending: '#0B81FF',
    archived: '#B3B3B3',
    declined: '#D74500',
    done: '#00C249',
    draft: '#0B81FF'
};
exports.fontColors = {
    dark: '#303030',
    light: '#FBFBFB',
    secondaryButton: '#7664F2',
    greyedOut: '#8F8F8F',
    lightGrey: '#8D9099'
};
exports.gradientsColors = {
    100: {
        primaryColor: '#7276F7',
        secondaryColor: '#7C40E8'
    },
    200: {
        primaryColor: '#FF9900',
        secondaryColor: '#EE5309'
    }
};
exports.borderColors = {
    dark: '#404D7A',
    light: '#E3E3E3',
    lightGrey: '#ACACAC',
    darkGrey: '#303030',
    purple: '#7276F7'
};
exports.profileColors = {
    100: '#EE5209',
    200: '#FF9900',
    300: '#5BDED3',
    400: '#0B81FF',
    500: '#BD2DFF'
};
exports.alertColors = {
    primaryLight: '#FBFBFB',
    secondaryLight: '#EBEBEB'
};
exports.selectionElementColors = {
    primaryDark: '#0B81FF',
    primaryBorderDark: '#FBFBFB',
    selectedRow: '#B7B8D9'
};
exports.elementColors = {
    blue: '#0B81FF',
    lightGrey: '#C4C4C4',
    purple: '#7276F7',
    100: '#F25409',
    200: '#F78854',
    300: '#8D9099'
};
exports.buttonColors = {
    100: '#8B1900'
};
